import { render, staticRenderFns } from "./controlHistory.vue?vue&type=template&id=0ab77bf1&scoped=true&lang=pug&"
import script from "./controlHistory.vue?vue&type=script&lang=js&"
export * from "./controlHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab77bf1",
  null
  
)

export default component.exports